import React from 'react';
import './offercard.scss';
import { Container, Row, Col } from 'react-bootstrap';

const OfferCards = ({heading,data,description}) => {

    
    return (
        <section className='we-offer'>
            <Container>
                <div className='common-heading'>
                    <h2>{heading}</h2>
                </div>
                <div className='description'>
                    <p>{description}</p>
                </div>
                <Row>
                    {data?.map((data) => (
                        <Col key={data.id} sm={12} md={4} lg={4} xl={4}>
                            <div className='common-card'>
                                {/* Content Section */}
                                <div className='Content'>
                                    <div className='sub-title'>
                                        <h4>{data.subtitle}</h4>
                                    </div>
                                    <div className='Heading'>
                                        <h3>{data.title}</h3>
                                    </div>
                                    <div className='Text'>
                                        <p>{data.description}</p>
                                    </div>
                                    <a className='link' href={data.linkUrl}>
                                        <span>{data.linkText}</span>
                                    </a>
                                </div>
                                {/* Image Section */}
                                <div className='Media'>
                                    <img
                                        alt='Two people talking'
                                        loading='lazy'
                                        src={data.imageUrl}
                                    />
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default OfferCards;
